module.exports = __webpack_public_path__ + "img/logo.874b5a52.svg";